<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <TextInput
                  v-model="form.name"
                  :label="$t('name')"
                  :tooltipMessage="$t('name')"
                  :required="true"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Credits"
                rules="required"
              >
                <TextInput
                  v-model="form.credits"
                  type="number"
                  :label="$t('dentalTwinCredits')"
                  :required="true"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Costs"
                rules="required"
              >
                <TextInput
                  v-model="form.costs"
                  type="number"
                  :label="$t('costs')"
                  :required="true"
                  :isRightIcon="true"
                  :rightIconName="'EuroIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label mb-2" style="display: block"
                >{{ $t("image") }}
              </label>
              <input type="file" @change="addFile($event)" accept="image/*" />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.freeCredits"
                type="number"
                :label="$t('freeDentalTwinCredits')"
                :required="false"
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-2">
        <router-link
          to="/packages"
          class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12" />
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <b-button
          variant="primary"
          @click="createPackage"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
          v-if="$can(`${$route.meta.permission}.create`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("createPackage") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [fileHandlerMixin, formDirtyMixin],
  computed: {
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("packages"),
          to: "/packages",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return !this.form.name || !this.form.credits || !this.form.costs;
    },
  },
  mounted() {
    this.originalForm = JSON.stringify(this.form);
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  data() {
    return {
      originalForm: null,
      form: {
        name: "",
        credits: "",
        costs: "",
        freeCredits: "",
        // freeCreditsText: "",
        image: {},
      },
      image: {},
    };
  },
  methods: {
    addFile(event) {
      const file = event.target.files[0];
      this.form.image = file;
    },
    async createPackage() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            if (this.form.image) {
              const response2 = await this.handleFileUpload(this.form.image);
              if (!response2?.data[0]?.id) {
                this.$store.commit("showLoader", false);
              } else {
                this.image = {
                  id: response2?.data[0]?.id,
                  name: response2?.data[0]?.originalFileName,
                  extension: response2?.data[0]?.type,
                };
              }
            }
            await this.$store.dispatch("packages/create", {
              ...this.form,
              image: this.image,
            });

            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            this.$router.push("/packages");
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
